import { render, staticRenderFns } from "./ProtospellingAutocomplete.vue?vue&type=template&id=4b1c80dc&scoped=true&"
import script from "./ProtospellingAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ProtospellingAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./ProtospellingAutocomplete.vue?vue&type=style&index=0&id=4b1c80dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c80dc",
  null
  
)

export default component.exports